module.exports = "/_next/static/images/game-2-intro-tutorial-underline2-86dfb432eb1d3e0d46e5c9b3d8a0a894.png";